import PropTypes from 'prop-types';
import React from 'react';

import Icon from '@ontruck/ontruck-react-components/lib/Icon';

import style from './style.module.scss';

const PDFItem = ({ onDelete }) => (
  <div className={style.pdfItem}>
    <span className={style.deleteButton} onClick={onDelete}>
      <Icon name="close" className={style.deleteIcon} />
    </span>
    <span className={style.pdfContainer}>PDF</span>
  </div>
);

PDFItem.propTypes = {
  onDelete: PropTypes.func,
};

export default PDFItem;
